
import { Vue, Component } from 'vue-property-decorator';
import 'animate.css';

@Component
export default class Home extends Vue {}
